:root {
  --breakpoints-desktop-breakpoint: 1440px;
  --breakpoints-desktop-columns: 12;
  --breakpoints-desktop-margin: 32px;
  --breakpoints-desktop-gutter: 24px;
  --breakpoints-desktop-sidebar-width: 196px;
  --breakpoints-mobile-breakpoint: 390px;
  --breakpoints-mobile-columns: 4;
  --breakpoints-mobile-margin: 16px;
  --breakpoints-mobile-gutter: 16px;
  --breakpoints-mobile-sidebar-width: 0px;
  --breakpoints-tablet-breakpoint: 834px;
  --breakpoints-tablet-columns: 8;
  --breakpoints-tablet-margin: 24px;
  --breakpoints-tablet-gutter: 20px;
  --breakpoints-tablet-sidebar-width: 156px;
}
